<template>
	<div class="MAM_brandList">
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 20px;">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleAddBrand">添加底薪奖规则</el-button>
			</div>
			<el-table :data="brandTable" size="mini" border style="width: 100%" max-height="500px" v-loading="loading">
					
				<el-table-column header-align="center" align="center" prop="level_name" label="名称" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" label="月新增有效商户数（≥）" prop="month_merchant_num" min-width="170">
                </el-table-column>
				<el-table-column header-align="center" align="center" label="户均交易量(万元)" prop="merchant_average_money" min-width="120">
				</el-table-column>
                <el-table-column header-align="center" align="center" label="新增商户活跃率(%)" prop="merchant_active_ratio" min-width="150">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="次月户均交易量(万元)" prop="last_month_average_money" min-width="150">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="次月有效商户复刷率(%)" prop="last_month_merchant_ratio" min-width="150">
                </el-table-column>
				<el-table-column header-align="center" align="center" label="奖励金额(元)" prop="reward_money" min-width="120">
				</el-table-column>
                <el-table-column header-align="center" align="center" label="关联活动" prop="group_name" min-width="120">
                </el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="update_time" label="更新时间" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="170">
                	
                    <template slot-scope="scope">
                    	<el-button v-if="scope.row.status == 1"  @click="editDataClick(scope.row)" type="text" size="small">编辑</el-button>
                    	<el-button v-if="scope.row.status == 1" @click='delClick(scope.row)' type="text" size="small">停用</el-button>
                        <span v-if="scope.row.status == 2" style="color: red;">已停用</span>
                    </template>
                </el-table-column>
			</el-table>
		</el-card>
		<!-- 添加 -->
		<el-dialog :title="isEdit?'编辑':'添加'" width="800px" :visible="addBrand" :close-on-click-modal="false" @close="handleClose">
			<el-form style = "width: 90%;" class="demo-form-inline" label-width="200px" :model="form" :rules="rules" ref="ruleForm">
				<el-form-item label="名称" prop="level_name">
					<el-input size clearable v-model="form.level_name" placeholder="请输入名称" style="width:90%;"></el-input>
				</el-form-item>
                <el-form-item label="月新增有效商户数（≥）" prop="month_merchant_num">
                	<el-input size clearable v-model="form.month_merchant_num" placeholder="请输入月新增有效商户数（≥）" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">位</span>
                </el-form-item>
                <el-form-item label="户均交易量(万元)" prop="merchant_average_money">
                	<el-input size clearable v-model="form.merchant_average_money" placeholder="请输入户均交易量(万元)" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">万元</span>
                </el-form-item>
                <el-form-item label="新增商户活跃率(%)" prop="merchant_active_ratio">
                	<el-input size clearable v-model="form.merchant_active_ratio" placeholder="请输入新增商户活跃率" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">%</span>
                </el-form-item>
                <el-form-item label="次月有效户复刷率(%)" prop="last_month_merchant_ratio">
                	<el-input size clearable v-model="form.last_month_merchant_ratio" placeholder="请输入次月有效户复刷率" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">%</span>
                </el-form-item>
                <el-form-item label="次月有效户均交易(万元)" prop="last_month_average_money">
                	<el-input size clearable v-model="form.last_month_average_money" placeholder="请输入次月有效户均交易(万元)" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">万元</span>
                </el-form-item>
                <el-form-item label="奖励金额(元)" prop="reward_money">
                	<el-input size clearable v-model="form.reward_money" placeholder="请输入奖励金额" style="width:90%;"></el-input>
                    <span style="margin-left: 10px;">元</span>
                </el-form-item>
				<el-form-item label="关联活动" prop="group_id">
					<el-select size clearable v-model="form.group_id" placeholder="请选择关联活动"  style="width:90%;">
						<el-option v-for="(item,index) in actionList" :label="item.group_name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="addSubmit('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "downSalaryAwardRuleList",
		inject: ['reload'],
		data() {
			return {
                actionList: [],
				brandTable: [],
				isEdit:false,
                pickerOptions: { //禁止选之前的时间
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    }
                },
				loading: true,
				//新增
				addBrand: false,
				form: {
					group_id: '',
                    level_name:'',
                    month_merchant_num:'',
                    merchant_average_money:'',
                    reward_money:'',
                    merchant_active_ratio:'',
                    last_month_merchant_ratio:'',
                    last_month_average_money:'',
                    id:''
				},
				rules: {
					level_name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
                    month_merchant_num: [{
                    	required: true,
                    	message: '请输入月新增有效商户数',
                    	trigger: 'blur'
                    }],
                    merchant_average_money: [{
                    	required: true,
                    	message: '请输入户均交易量(万元)',
                    	trigger: 'blur'
                    }],
                    merchant_active_ratio: [{
                    	required: true,
                    	message: '请输入新增商户活跃率',
                    	trigger: 'blur'
                    }],
                    last_month_average_money: [{
                    	required: true,
                    	message: '请输入次月有效户均交易(万元)',
                    	trigger: 'blur'
                    }],
                    last_month_merchant_ratio: [{
                    	required: true,
                    	message: '请输入次月有效户复刷率',
                    	trigger: 'blur'
                    }],
                    reward_money: [{
                    	required: true,
                    	message: '请输入奖励金额',
                    	trigger: 'blur'
                    }],
					group_id: [{
						required: true,
						message: '请选择关联活动',
						trigger: 'change'
					}]
				}
			}
		},
		mounted() {
			this.getData({
				page: 1,
				limit: 100,
			})
            this.$api.post('user_dividends/userBasicSalaryGroupPage', {
            	page: 1,
            	limit: 1000,
            }, res => { //获取管理奖规则
            	if (res.code == 0) {
            		let arr = res.data.list;
                    for (let item of arr) {
                        if (item.status == 1) {
                            this.actionList.push(item)
                        } 
                    }
            	} else {
            		this.$$message.success(res.msg);
            	}
            });
		},
		methods: {
            
            
            editDataClick(item){
                this.addBrand = true;
                this.isEdit = true
                this.form.level_name = item.level_name
                this.form.month_merchant_num = item.month_merchant_num
                this.form.merchant_average_money = item.merchant_average_money
                this.form.merchant_active_ratio = item.merchant_active_ratio
                this.form.last_month_average_money = item.last_month_average_money
                this.form.last_month_merchant_ratio = item.last_month_merchant_ratio
                this.form.group_id = item.group_id
                this.form.reward_money = item.reward_money
                this.form.id = item.id
                
            },
            
            delClick(item) {
                this.$confirm('是否确定停用？', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
                	   this.$api.post("user_dividends/userBasicSalaryLevelStatus", {id:item.id,status:2}, res => {
                		   if (res.code == 0) {
                			   this.$message.success(res.msg);
                			   this.getData({
                			   	page: 1,
                			   	limit: 100,
                			   })
                		   }else {
                			   this.$message.error(res.msg);
                		   }
                	   })
                	
                	
                }).catch(err=>{});
            },
            
			//档位配置  提交(编辑)
			addSubmit(formName) {
				console.log(this.form)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post("user_dividends/saveUserBasicSalaryLevel", this.form, res => {
							if (res.code == 0) {
								this.addBrand = false;
								this.$message({
									type: 'success',
									message: res.msg,
									duration: 2000,
								})
								this.$refs[formName].resetFields();
								this.form = {
									group_id: '',
									level_name:'',
									month_merchant_num:'',
									merchant_average_money:'',
									reward_money:'',
									merchant_active_ratio:'',
                                    last_month_average_money:'',
                                    last_month_merchant_ratio:'',
									id:''
								};
								this.getData({
									page: 1,
									limit: 100,
								})
							}else{
								this.$message({
									type: 'error',
									message: res.msg,
									duration: 2000,
								})
							}
						})
					}
				});
			},
			//打开  关闭   新增配置
			handleAddBrand() {
                this.isEdit = false
				this.addBrand = true;
			},
			handleClose() {
				this.addBrand = false;
				this.$refs.ruleForm.resetFields();
				this.form = {
					group_id: '',
					level_name:'',
					month_merchant_num:'',
                    merchant_average_money:'',
					reward_money:'',
					merchant_active_ratio:'',
                    last_month_average_money:'',
                    last_month_merchant_ratio:'',
					id:''
				};
			},

			getData(params) {
				this.$api.post("user_dividends/userBasicSalaryLevelPage", params, res => {
					let data = res.data;
					this.brandTable = data.list;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
		}
	};
</script>

<style lang="scss" scoped>
	.tableDiv {
		overflow-x: scroll;
	}
	.el-form-item {
		margin-bottom: 20px !important;
	}
</style>